export default {
  token: null,
  principal: {
    user: {
      id: null,
      brand: null,
      brands: null,
      username: null,
      userGroup: {
        defaultCurrency: {
          id: null
        },
        defaultCountry: {
          id: null
        }
      }
    },
    partyGroups: [],
    settings: []
  },
  defaultPrincipal: {
    user: {
      id: null,
      brand: null,
      brands: null,
      username: null,
      userGroup: {
        defaultCurrency: {
          id: null
        },
        defaultCountry: {
          id: null
        }
      }
    },
    partyGroups: [],
    settings: []
  },
  /*
  * Default refresh every 10 seconds
  */
  expiresIn: 10000,
  expiresFrom: null,
  hasCurrentActiveRequest: false
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/state.js